import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './assets/css/global.css';
// import './assets/css/tailwind.css';

import diVueMask from 'di-vue-mask';
import './plugins/axios';
import './plugins/print';
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.config.productionTip = false

const globalLayoutFix = document.createElement('style')
globalLayoutFix.setAttribute('data-global-layout-fix', 'true')
globalLayoutFix.innerHTML = `
  html,
  body,
  #app,
  .v-application,
  .v-application--wrap,
  .v-main,
  .v-main__wrap {
    width: 100vw !important;
    min-width: 100vw !important;
    min-height: 100vh !important;
    margin: 0 !important;
    padding: 0 !important;
    background-color: #f8fafc !important;
  }

  body {
    overflow-x: hidden !important;
  }

  .v-application,
  .v-main,
  .v-main__wrap {
    background-color: #f8fafc !important;
  }
`
document.head.appendChild(globalLayoutFix)
document.documentElement.style.backgroundColor = '#f8fafc'
document.body.style.backgroundColor = '#f8fafc'
document.body.style.margin = '0'
document.body.style.overflowX = 'hidden'

Vue.use(Chartkick.use(Chart))
Vue.use(diVueMask)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
